module.exports = __webpack_public_path__ + "img/legyuan.2b9cae8e.jpg";